import React, { Component, lazy, Suspense } from 'react';

const introPage = lazy(() => import('./ThreedxApiExamplesIntroduction'))
const productPageTemplatePage1 = lazy(() => import('./Examples/ProductPageApiExampleTemplate1'));
const productPageTemplatePage2 = lazy(() => import('./Examples/ProductPageApiExampleTemplate2'));
const previewDownloadTemplatePage3 = lazy(() => import('./Examples/PreviewDownloadApiExampleTemplate3'));
const partNumberPreviewTemplatePage4 = lazy(() => import('./Examples/PartNumberPreviewApiExampleTemplate4'));
const partNumberPreviewDialogTemplatePage5 = lazy(() => import('./Examples/PartNumberPreviewDialogApiExampleTemplate5'));
const previewDownloadPartNumberDialogTemplatePage6 = lazy(() => import('./Examples/PreviewDownloadPartNumberDialogApiExampleTemplate6'));
const iframeEventsTemplatePage7 = lazy(() => import('./Examples/EventsApiExampleTemplate7'));

class ThreedxApiExamples extends Component {
  getApiTemplatePage = (pageTitle) => {
    switch(pageTitle)
    {
      default:
        case 'toc':
          return { Component: introPage, LoadingMsg: "Loading 3DX API Sample Introduction..." }
        case 'productpageexample-1':
          return { Component: productPageTemplatePage1, LoadingMsg: "Loading 3DX API Sample Template..." };
        case 'productpageexample-2':
          return { Component: productPageTemplatePage2, LoadingMsg: "Loading 3DX API Sample Template..." };
        case 'previewdownloadexample-3':
          return { Component: previewDownloadTemplatePage3, LoadingMsg: "Loading 3DX API Sample Template..." };
        case 'partnumberpreviewexample-4':
          return { Component: partNumberPreviewTemplatePage4, LoadingMsg: "Loading 3DX API Sample Template..." };
        case 'partnumberpreviewdialogexample-5':
          return { Component: partNumberPreviewDialogTemplatePage5, LoadingMsg: "Loading 3DX API Sample Template..." };
        case 'previewdownloadpartnumberdialogexample-6':
          return { Component: previewDownloadPartNumberDialogTemplatePage6, LoadingMsg: "Loading 3DX API Sample Template..." };
        case 'iframeeventsexample-7':
          return { Component: iframeEventsTemplatePage7, LoadingMsg: "Loading 3DX API Sample Template..." };
         }
  }

  render () {
    const SampleTemplatePage = this.getApiTemplatePage(this.props.match.params.id);
    return (
      <Suspense fallback={<div>{SampleTemplatePage.LoadingMsg}</div>}>
        <SampleTemplatePage.Component {...this.props}/>
        <br></br>
      </Suspense>
    );
  }
}

export default ThreedxApiExamples;



// WEBPACK FOOTER //
// ./src/containers/ThreedxApiExamples/ThreedxApiExamples.js